import React from "react";
import CTA from "./CTA";
import "./Header.css";
import { TypeAnimation } from "react-type-animation";

import HeaderSochial from "./HeaderSochial";

const Header = () => {
  return (
    <header>
      <div id="header" className="container header__container">
        <h5 className="hh5">Hello I'm</h5>
        <h1 className="name-head">Abubakar Mahboob</h1>
        <h5 className="text-light changing-text">
          <TypeAnimation
            sequence={[
              // Same substring at the start will only be typed once, initially
              "Frontend Website Developer",
              1000,
              "ReactJS Developer",
              1000,
              "Redux Store Management",
              1000,
              "ReactJS Hooks",
              1000,
            ]}
            speed={50}
            /* style={{ fontSize: "2em" }} */
            repeat={Infinity}
          />
        </h5>

        <CTA />
        <HeaderSochial />

        {/*     <div className="me">
          <Roll right>
            <img src={me2} alt="" />
          </Roll>
        </div> */}

        <a href="#conntact" className="scroll__down">
          Scroll Down ->
        </a>
      </div>
    </header>
  );
};

export default Header;
